export default __webpack_public_path__ + "static/media/IvoryvaleMap.7ce2a8f8.jpg";